"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _Icon = _interopRequireDefault(require("../../../Icon/Icon"));

var _BaseButton = _interopRequireDefault(require("../../../Buttons/BaseButton"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var SearchFilter = function SearchFilter(_ref) {
  var value = _ref.value,
      onSearch = _ref.onSearch,
      onClose = _ref.onClose,
      onToggleOpen = _ref.onToggleOpen;

  var _useTheme = (0, _material.useTheme)(),
      palette = _useTheme.palette;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isSearchOpen = _useState2[0],
      setIsSearchOpen = _useState2[1];

  var clearVisible = !!value;
  var handleToggleOpen = (0, _react.useCallback)(function (isOpen) {
    if (onToggleOpen) {
      onToggleOpen(isOpen);
    }
  }, [onToggleOpen]);
  var handleOpenSearch = (0, _react.useCallback)(function () {
    setIsSearchOpen(true);
    handleToggleOpen(true);
  }, [handleToggleOpen]);
  var handleSearch = (0, _react.useCallback)(function (e) {
    onSearch(e.target.value);
  }, [onSearch]);
  var handleClear = (0, _react.useCallback)(function () {
    setIsSearchOpen(false);
    onSearch('');
    onClose('');
    handleToggleOpen(false);
  }, [onSearch, onClose, handleToggleOpen]);
  var handleClose = (0, _react.useCallback)(function () {
    setIsSearchOpen(false);
    onClose(value);
    handleToggleOpen(false);
  }, [onClose, value, handleToggleOpen]);
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    mr: 2,
    width: "auto"
  }, !isSearchOpen && /*#__PURE__*/_react["default"].createElement(_BaseButton["default"], {
    width: 48,
    variant: "outlined",
    "data-testid": "search-collapsed-button",
    onClick: handleOpenSearch,
    color: palette.link.main,
    bgColor: palette.common.white,
    borderColor: palette.grey.regular
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    color: "customStyling.highlightColor",
    className: "pt1-ie"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "search"
  }))), isSearchOpen && /*#__PURE__*/_react["default"].createElement(_material.ClickAwayListener, {
    onClickAway: handleClose
  }, /*#__PURE__*/_react["default"].createElement(_material.TextField, {
    autoFocus: true,
    fullWidth: true,
    variant: "outlined",
    value: value,
    onChange: handleSearch,
    "data-testid": "search-input",
    placeholder: "Search",
    InputProps: _objectSpread({
      startAdornment: /*#__PURE__*/_react["default"].createElement(_material.InputAdornment, {
        position: "start"
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        icon: "search",
        color: "grey"
      }))
    }, clearVisible ? {
      endAdornment: /*#__PURE__*/_react["default"].createElement(_material.InputAdornment, {
        position: "end"
      }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
        color: "customStyling.highlightColor"
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        icon: "times",
        className: "Text-Pointer",
        onClick: handleClear
      })))
    } : {})
  })));
};

var _default = /*#__PURE__*/(0, _react.memo)(SearchFilter);

exports["default"] = _default;